// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inactive-devices-reports-page{
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
}
.inactive-devices-reports-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.inactive-devices-reports-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.inactive-devices-reports-container{
    width: 85%;
    height: 85%;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    padding: 2% 3%;
    border-radius: 10px;
    position: relative;
}
@media screen and (max-width:949px){
    .inactive-devices-reports-container{
        height: 78vh;
        margin-top: 2vh;
        overflow: auto;
    }
}
.inactive-devices-reports-header-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.inactive-devices-reports-header-container h2{
    font-weight: lighter;
    color: rgb(90, 90, 90);
}
@media screen and (max-width:949px){
    .inactive-devices-reports-header-container h2{
        font-size: 16px;
    }
}
.inactive-devices-reports-header-controls{
    display: flex;
    align-items: center;
}
.inactive-devices-reports-server-url-select{
    margin: 0px;
    padding: 4px 16px;
    margin-right: 10px;
    font-size: 14px;
    border: none;
    outline: none;
    border-radius: 4px;
    background-color: rgb(222, 229, 233);
}
@media screen and (max-width:949px){
    .server-url-select{
        font-size: 12px;
        width: 40vw;
    }
}
.add-new-inactive-devices-report-button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 2px 4px;
}
.add-new-inactive-devices-report-button:hover{
    background-color: rgb(214, 214, 214);
}
.add-new-inactive-devices-report-button img{
    height: 30px;
}
.refresh-inactive-devices-reports-button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 5px 7px;
}
.refresh-inactive-devices-reports-button:hover{
    background-color: rgb(214, 214, 214);
}
.refresh-inactive-devices-reports-button img{
    height: 25px;
}
@media screen and (max-width:949px){
    .inactive-devices-reports-body-container{
        width: 100%;
        overflow: auto;
    }
}
.inactive-devices-reports-body-container table{
    width: 100%;
    border-collapse: collapse;
}
.inactive-devices-reports-body-container table tr{
    cursor: pointer;
}
.inactive-devices-reports-body-container table th,
.inactive-devices-reports-body-container table td{
    text-align: left;
}
@media screen and (max-width:949px){
    .inactive-devices-reports-body-container table th,
    .inactive-devices-reports-body-container table td{
        white-space: nowrap;
    }
}
.inactive-devices-reports-body-container table th{
    font-weight: 600;
    padding: 10px 0px;
}
.inactive-devices-reports-body-container table td{
    padding: 4px 0px;
}
@media screen and (max-width:949px){
    .inactive-devices-reports-body-container table th{
        font-size: 14px;
        font-weight: 500;
        padding-right: 10px;
    }
    .inactive-devices-reports-body-container table td{
        font-size: 12px;
        padding-right: 10px;
    }
}
.inactive-devices-reports-body-container table img{
    height: 20px;
    cursor: pointer;
}
#inactive-devices-reports-table-header-row{
    background-color: transparent;
}
.inactive-devices-reports-body-container table tr:nth-child(odd){
    background-color: rgba(206, 206, 206, 0.953);
}
.inactive-devices-reports-body-container table tr:nth-child(even){
    background-color: rgb(242, 242, 242);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/InactiveDevicesReports.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;AACnD;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,sCAAsC;IACtC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI;QACI,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI;QACI,eAAe;QACf,WAAW;IACf;AACJ;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI;;QAEI,mBAAmB;IACvB;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,oCAAoC;AACxC","sourcesContent":[".inactive-devices-reports-page{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    height: 100vh;\r\n    box-sizing: border-box;\r\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n.inactive-devices-reports-page-layout{\r\n    height: 90%;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n.inactive-devices-reports-parent-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.inactive-devices-reports-container{\r\n    width: 85%;\r\n    height: 85%;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    padding: 2% 3%;\r\n    border-radius: 10px;\r\n    position: relative;\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-reports-container{\r\n        height: 78vh;\r\n        margin-top: 2vh;\r\n        overflow: auto;\r\n    }\r\n}\r\n.inactive-devices-reports-header-container{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.inactive-devices-reports-header-container h2{\r\n    font-weight: lighter;\r\n    color: rgb(90, 90, 90);\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-reports-header-container h2{\r\n        font-size: 16px;\r\n    }\r\n}\r\n.inactive-devices-reports-header-controls{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.inactive-devices-reports-server-url-select{\r\n    margin: 0px;\r\n    padding: 4px 16px;\r\n    margin-right: 10px;\r\n    font-size: 14px;\r\n    border: none;\r\n    outline: none;\r\n    border-radius: 4px;\r\n    background-color: rgb(222, 229, 233);\r\n}\r\n@media screen and (max-width:949px){\r\n    .server-url-select{\r\n        font-size: 12px;\r\n        width: 40vw;\r\n    }\r\n}\r\n.add-new-inactive-devices-report-button{\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    padding: 2px 4px;\r\n}\r\n.add-new-inactive-devices-report-button:hover{\r\n    background-color: rgb(214, 214, 214);\r\n}\r\n.add-new-inactive-devices-report-button img{\r\n    height: 30px;\r\n}\r\n.refresh-inactive-devices-reports-button{\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    padding: 5px 7px;\r\n}\r\n.refresh-inactive-devices-reports-button:hover{\r\n    background-color: rgb(214, 214, 214);\r\n}\r\n.refresh-inactive-devices-reports-button img{\r\n    height: 25px;\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-reports-body-container{\r\n        width: 100%;\r\n        overflow: auto;\r\n    }\r\n}\r\n.inactive-devices-reports-body-container table{\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n.inactive-devices-reports-body-container table tr{\r\n    cursor: pointer;\r\n}\r\n.inactive-devices-reports-body-container table th,\r\n.inactive-devices-reports-body-container table td{\r\n    text-align: left;\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-reports-body-container table th,\r\n    .inactive-devices-reports-body-container table td{\r\n        white-space: nowrap;\r\n    }\r\n}\r\n.inactive-devices-reports-body-container table th{\r\n    font-weight: 600;\r\n    padding: 10px 0px;\r\n}\r\n.inactive-devices-reports-body-container table td{\r\n    padding: 4px 0px;\r\n}\r\n@media screen and (max-width:949px){\r\n    .inactive-devices-reports-body-container table th{\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        padding-right: 10px;\r\n    }\r\n    .inactive-devices-reports-body-container table td{\r\n        font-size: 12px;\r\n        padding-right: 10px;\r\n    }\r\n}\r\n.inactive-devices-reports-body-container table img{\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n#inactive-devices-reports-table-header-row{\r\n    background-color: transparent;\r\n}\r\n.inactive-devices-reports-body-container table tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206, 0.953);\r\n}\r\n.inactive-devices-reports-body-container table tr:nth-child(even){\r\n    background-color: rgb(242, 242, 242);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
